
import { Badge } from "@/components/ui/badge";
import { Database } from "@/integrations/supabase/types";
import { getDayLabel } from "./utils";
import { useMemo } from "react";

type Weekday = Database["public"]["Enums"]["weekday"];

interface DayBadgesProps {
  selectedDays: Weekday[];
}

export const DayBadges = ({ selectedDays }: DayBadgesProps) => {
  // Memoize para evitar re-renders innecesarios pero sin estado interno conflictivo
  const memoizedDays = useMemo(() => selectedDays, [selectedDays]);

  console.log("🎨 DayBadges - Direct render with optimized logic:", {
    selectedDays: memoizedDays,
    count: memoizedDays.length,
    timestamp: new Date().toISOString()
  });

  // No renderizar nada si no hay días seleccionados
  if (!memoizedDays || memoizedDays.length === 0) {
    console.log("📭 DayBadges - No days to display, returning null");
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {memoizedDays.map((day, index) => (
        <Badge 
          key={`${day}-${index}`}
          variant="secondary" 
          className="bg-primary/60 dark:text-white hover:bg-primary/90 transition-all duration-300 animate-slide-up"
          style={{ 
            animationDelay: `${index * 0.05}s`,
          }}
        >
          {getDayLabel(day)}
        </Badge>
      ))}
    </div>
  );
};
